import debounce from "lodash/debounce";
import { FORM_SUBMIT_DEBOUNCE_MS } from "util/constants";

export default class BaseStorageProvider {
    constructor() {
        this.save = debounce(this._save, FORM_SUBMIT_DEBOUNCE_MS, {
            leading: true,
            trailing: false
        });
        this.delete = debounce(this._delete, FORM_SUBMIT_DEBOUNCE_MS, {
            leading: true,
            trailing: false
        });
    }

    get(dispatcher, callback) {
        callback(null, { body: { success: true, results: {} } });
    }

    _save(dispatcher, data, callback) {
        callback(null, { body: { success: true, result: data } });
    }

    _delete(dispatcher, callback) {
        callback(null, { body: { success: true } });
    }
}
